﻿import "select2";
import Switchery from "../../../../Fundraising.UI.Shared/Vendor/switchery/js/switchery";
import { DatePicker } from "../../../../Fundraising.UI.Shared/Modules/datePicker/TimeDatePicker";
import { AjaxSessionHandler } from "../../../../Fundraising.UI.Shared/Modules/account/AjaxSessionHandler";

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Util = {};

    // Private Variables
    const switches = [];
    const datePickers = [];
    let switchesProcessed = false;

    const set401AjaxHandler = () => {
        const unauthorizedRedirectUrl = M2.Util.config.unauthorizedRedirectUrl;
        new AjaxSessionHandler().unauthorizedRedirect(unauthorizedRedirectUrl);
    }

    function setDivLabel() {
        $(document).on("click", "div.label", function () {
            const forTarget = $(this).attr("for");
            $("#" + forTarget).trigger("click");
        });
    }

    function setUserMenu() {
        var $userMenu = $('.user-menu');
        $(document).on({
            mouseenter: function () {
                $userMenu.addClass('show-menu');
            },
            mouseleave: function () {
                $userMenu.removeClass('show-menu');
            },
            touchstart: function () {
                $userMenu.addClass('show-menu');
            }
        }, '.user-menu');

        $(document).on('touchstart', 'body', function (e) {
            // If the target of the click isn't the container
            if (!$userMenu.is(e.target) && $userMenu.has(e.target).length === 0) {
                $userMenu.removeClass('show-menu');
            }
        });
    }

    function saveDatePicker(key, value) {
        datePickers[key] = value;
    }

    function getDatePicker(key) {
        return datePickers[key];
    }

    function saveSwitch(key, value) {
        switches[key] = value;
    }

    function getSwitch(key) {
        return switches[key];
    }

    function getAllSwitches() {
        return switches;
    }

    function setTheme() {
        const isGSA = $('body').hasClass('gsa');
        const isFunderworks = $('body').hasClass('school');
        const isWFC = $('body').hasClass('wfc');
        const isGivingMarket = $('body').hasClass('gm');
        const theme = isGSA ? "gsa" : isFunderworks ? "school" : isWFC ? "wfc" : isGivingMarket ? "gm" : "";
        M2.Util.config.theme = theme;
    }

    function disableSubmission(btn) {
        // Disable the buttons immediatly
        $(btn).addClass('disabled').attr('disabled', 'disabled');
    }
    function enableSubmission(btn) {
        // Re-enable the button as we've found suggestions
        $(btn).removeClass('disabled').removeAttr('disabled');
    }

    function setGroupSelector() {
        $("#content").on("change", ".leader-groups select, .group-select select, .leader-units select", function (e) {
            $(this).closest('form').submit();
        });
    }
    function setOverlayTriggers() {
        /* ######## Start Overlay ########## */
        $(document).on("click", ".close-add-group, .close-add-participant, .close-add-group-leader, .close-add-administrator", function (e) {
            e.preventDefault();
            $(this).closest("form").trigger("reset");
            $("#GroupEditGroupLeader_GroupId").trigger('select2:close');
        });
        /* ######## End Overlay ########## */
    }

    function setReEnterAddress() {
        $(document).on("click", ".re-enter-address", function (e) {
            e.preventDefault();
            M2.Modal.close();
        });
    }

    function selectAddress() {
        $(document).on("click", ".select-address.btn", function (e) {
            e.preventDefault();

            $(".address-suggestions input[type='radio']:checked").each(function () {
                let target = $(this).val();
                target = $(target);
                var txt = $(this).attr("name");
                var numb = txt.match(/\d/g);
                const addressId = numb.join("");

                if (target.attr("id") !== "address-choice-default") {

                    $("#AddressLine1").val(target.find(".address1").html());
                    $("#AddressLine2").val(target.find(".address2").html());
                    $("#City").val(target.find(".city").html());
                    $("#State").val(target.find(".state").html());
                    $("#Zip").val(target.find(".zip").html());
                }
            });
            M2.Util.submitForm(".patch-earner form", ".select-address.btn");
            M2.Modal.close();
        });
    }

    function removeActionMenu() {
        var $body = $('body');
        $body.removeClass('action-menu-visible');
        $(".action-menu").fadeOut();
        $(".action-menu-trigger").removeClass("active");
        $(".action-menu-trigger svg.am").attr('data-icon', 'plus');
        $(".__msg_overlay").remove();
    }
    function setActionMenu() {
        $(document).on("click", ".action-menu-trigger svg.am", function (e) {
            e.preventDefault();
            var $body = $('body');

            /* Close any open Action Menus */

            $(".action-menu").fadeOut();
            $(".action-menu-trigger").removeClass("active");

            /* Open Current Action Menu */

            var $parent = $(this).parent();
            var $icon = $(this);
            var $menu = $(this).parent().find(".action-menu");

            if ($icon.attr('data-icon') === 'plus') {
                M2.Util.createOverlayBG("__msg_overlay");
                $menu.fadeIn();
                $icon.attr('data-icon', 'xmark');
                $parent.addClass("active");
                $body.addClass('action-menu-visible');
            } else {
                removeActionMenu();
            }
        });
        // Turn off Action Menu when open and clicking outside drop down
        $(document).on('click', function (event) {
            if ($(event.target).closest('.action-menu-visible').length && !$(event.target).closest('.action-menu, .action-menu-trigger').length) {
                removeActionMenu();
            }
        });

        $(document).on('click', '.m2-modal', function () {
            removeActionMenu();
        });
    }
    function setVideoEmbedLinks() {
        $(".LimelightEmbeddedPlayer table a").prop("target", "_new");
    }
    function setDashboardQuickLinks() {
        $(document).on('click', '.dql-trigger', function (e) {
            e.preventDefault();
            const $body = $("body");
            var $dashQuickLinksOuter = $('#dashboard-quick-links-container');
            var $dashQuickLinksContainer = $('#dashboard-quick-links');
            var panelIsClosed = !$dashQuickLinksContainer.hasClass('open');
            var iconsURL = $('#dashboard-menu-url').val();

            var $triggerIcon = $(this).find('svg');
            var $triggerLabel = $(this).find('.trigger-label');
            var hideLabel = $(this).data('label-hide');
            var showLabel = $(this).data('label-show');

            if (panelIsClosed) {
                if (iconsURL) {
                    $.ajax({
                        url: iconsURL,
                        beforeSend: M2.Util.displayLoad($dashQuickLinksContainer)
                    }).done(function (data) {
                        $($dashQuickLinksContainer).html(data);
                        $body.addClass("nav-is-open");
                        $dashQuickLinksOuter.addClass('is-open');
                        $dashQuickLinksContainer.addClass('open');
                        $dashQuickLinksContainer.slideDown('fast');
                        $triggerIcon.attr('data-icon', 'caret-up');
                        $triggerLabel.text(hideLabel);

                    }).fail(function (request, status, error) {
                        alert('An unexpected error occured.');
                        $dashQuickLinksContainer.empty();
                    });
                }
            } else {
                $dashQuickLinksContainer.slideUp('fast', function () {
                    $body.removeClass("nav-is-open");
                    $dashQuickLinksOuter.removeClass('is-open');
                    $dashQuickLinksContainer.removeClass('open');
                    $triggerIcon.attr('data-icon', 'caret-down');
                    $triggerLabel.text(showLabel);
                });
            }
        });
    }
    function displayError() {
        if ($('.error-container').children().length >= 1) {
            $('.error-container').css('display', 'block');
        }
    }
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    // File Loaders
    function setFileDownloadLoaders() {
        $(document).on('click', '.download-loader', function (e) {
            e.preventDefault();
            // Grab all our data
            var $link = $(this);
            var href = $link.attr('href');
            var $icon = $link.find('i');
      
            if ($link.hasClass('loading')) return false;
            else {
                // Set trigger link to loading state
                $link.addClass('loading disabled');

                // Find icon, save the current state, and replace it with the loader
                var activeStateIcon = $icon.attr('class');
                var loadingStateIcon = 'fas fa-sync fa-spin';
                $icon.attr('class', loadingStateIcon);

                var oReq = new XMLHttpRequest();
                oReq.open('GET', href, true);
                oReq.responseType = 'arraybuffer';

                oReq.onload = function (oEvent) {
                    var fileType = oReq.getResponseHeader('Content-Type');
                    var fileName;
                    var allHeaders = oReq.getAllResponseHeaders();
                    var disposition = allHeaders.indexOf('content-disposition') !== -1 ? oReq.getResponseHeader('Content-Disposition') : false;

                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(disposition);
                        fileName = matches !== null && matches[1] ? matches[1].replace(/['"]/g, '') : 'unknown.txt';
                    } else {
                        fileName = href.split('/').pop();
                    }

                    var arrayBuffer = oReq.response;
                    var byteArray = new Uint8Array(arrayBuffer);
                    var blob = new Blob([arrayBuffer], { type: fileType });
                    var url = URL.createObjectURL(blob);

                    // IE Needs this
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        // Everyone else
                        var a = document.createElement('a');
                        a.style.display = 'none';
                        a.setAttribute('download', fileName);
                        a.href = url;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }

                    $link.removeClass('loading disabled');
                    $icon.attr('class', activeStateIcon);

                };

                oReq.onerror = function (e) {
                    $link.removeClass('loading disabled');
                    $icon.attr('class', activeStateIcon);
                };

                oReq.send();
            }
        });
    }
    function setTabDropDown() {
        $(document).on('click', 'nav.tabs a.active', function (e) {
            e.preventDefault();
            var $dropDownContainer = $(this).closest('nav.tabs');
            if (!$dropDownContainer.hasClass('nav-open')) $dropDownContainer.addClass('nav-open');
            else $dropDownContainer.removeClass('nav-open');
        });
    }

    function setConfigOptions() {
        // Set config options
        if ('undefined' !== typeof M2_Util_language) M2.Util.config.language = M2_Util_language;
        if ('undefined' !== typeof M2_Util_pathToImages) M2.Util.config.pathToImages = M2_Util_pathToImages;
        if ('undefined' !== typeof M2_Util_unauthorizedRedirectUrl) M2.Util.config.unauthorizedRedirectUrl = M2_Util_unauthorizedRedirectUrl;
    }

    function getAdjustedCharacterCount(charsEntered) {
        const numberOfLineBreaks = getNumLineBreaks(charsEntered);
        return charsEntered.length + numberOfLineBreaks;
    }

    function getNumLineBreaks(charsEntered) {
        return (charsEntered.match(/\n/g) || []).length;
    }

    function setCharacterLimitTools() {
        $(document).on("change, keyup", ".char-limit", function (e) {
            const $input = $(this);
            const charCounterSeletor = $input.data("char-counter-selector");
            const $characterCounter = $(charCounterSeletor);
            const limit = parseInt($input.attr('maxlength'));
            countChar($input, $characterCounter, limit);
        });
    }

    function countChar($input, $characterCounter, limit) {
        const charsEntered = $input.val();
        const maxLength = limit;
        const adjustedCharCount = getAdjustedCharacterCount(charsEntered);
        let remainingChars = maxLength - adjustedCharCount;

        if (remainingChars < 0) {
            $input.val($input.val().substr(0, maxLength - getNumLineBreaks(charsEntered)));
            remainingChars = 0;
        }

        remainingChars = parseInt(remainingChars).toLocaleString();
        $characterCounter.find("span.count").html(remainingChars);
    }

    function groupSearch($selector, placeholder, searchUrl, paramName, width) {
        width = width || "auto";

        return $selector.select2({
            minimumResultsForSearch: 10,
            dropdownAutoWidth: true,
            minimumInputLength: 1,
            width: width,
            placeholder: placeholder,
            ajax: {
                url: searchUrl,
                dataType: 'json',
                delay: 500,
                data: function (params) {
                    var query = {};
                    query[paramName] = params.term;
                    return query;
                },
                processResults: function (data) {
                    var select2Format = [];
                    Object.keys(data).forEach(function (key) {
                        var jsonData = {};
                        if (data[key].groupId === '') data[key].groupId = 'null';
                        jsonData['id'] = data[key].groupId;
                        jsonData['text'] = data[key].identifier;
                        select2Format.push(jsonData);
                    });
                    return {
                        results: select2Format
                    };
                }
            }
        })
    }

    M2.Util = {
        config: {
            name: "M2 Fundraising Utilities",
            pathToImages: "",
            selectIgnoreStyleSelector: ".native-style, .hidden, .select2"
        },
        isMobile: {
            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (M2.Util.isMobile.Android() || M2.Util.isMobile.BlackBerry() || M2.Util.isMobile.iOS() || M2.Util.isMobile.Opera() || M2.Util.isMobile.Windows());
            }
        },
        init: function () {
            setConfigOptions();
            this.setSwitches( () => {
                this.setRevealTargets();
            });
            setTheme();
            setOverlayTriggers();
            setTabDropDown();
            this.setDates();
            M2.Util.setTimePicker();
            M2.Util.resetFilter();
            M2.Util.activatePrint();
            setGroupSelector();
            setReEnterAddress();
            selectAddress();
            setActionMenu();
            setVideoEmbedLinks();
            M2.Util.setSearchTools();
            this.decorateField();
            this.setInputMasks();
            this.setAddDrilldownPage();
            this.setDrilldownTableRow();
            this.setDrilldownLink();
            setDashboardQuickLinks();
            displayError();
            setUserMenu();
            setFileDownloadLoaders();

            this.textAreaLimiter();
            setDivLabel();
            //this.setOrgSearch();
            this.setiframeSelfResize();
            setCharacterLimitTools();
            this.setGroupSearch();
            set401AjaxHandler();
        },
        setRemainingCount: function() {
            $('.char-limit').each(function () {
                const $input = $(this);
                const charCounterSelector = $input.data("char-counter-selector");
                const $characterCounter = $(charCounterSelector);
                const limit = parseInt($input.attr('maxlength')).toLocaleString();
                $characterCounter.find("span.count").html(limit);
            });
        },
        setSwitches: function (callback=null) {
            switchesProcessed = false;
            const filterExistingSwitches = (inputs) => {
                inputs = inputs.filter(function (input) {
                    return input.style.display !== "none";
                });
                return inputs;
            }

            const createSwitches = (switches, theme = null, classes = null) => {
                const opts = {};
                if (theme) opts.color = theme;
                if (classes) opts.className = classes;

                switches.forEach(function (html) {
                    var switchery = new Switchery(html, opts);
                    saveSwitch(html.id, switchery);
                });
            }

            const standardSwitch = filterExistingSwitches(Array.prototype.slice.call(document.querySelectorAll('.switch')));
            const warningSwitch = filterExistingSwitches(Array.prototype.slice.call(document.querySelectorAll('.switch-warning')));
            const smallSwitches = filterExistingSwitches(Array.prototype.slice.call(document.querySelectorAll('.switch-small')));        

            if (M2.Util.isIframe()) {
                const iFrameDelay = 250;
                window.setTimeout(() => {
                    createSwitches(standardSwitch);
                    createSwitches(warningSwitch, "#B33A3A", "switchery warning-switch");
                    createSwitches(smallSwitches, null, "switchery small-switch");
                    switchesProcessed = true;
                    if (callback) {
                        callback();
                    }
                }, iFrameDelay);
            } else {
                createSwitches(standardSwitch);
                createSwitches(warningSwitch, "#B33A3A", "switchery warning-switch");
                createSwitches(smallSwitches, null, "switchery small-switch");
                switchesProcessed = true;
                if (callback) {
                    callback();
                }
            }
        },
        setSwitchery: function (switchElement, checkedBool, clickEvent) {
            if ((checkedBool && !switchElement.isChecked()) || (!checkedBool && switchElement.isChecked())) {
                switchElement.setPosition(true);
                if (clickEvent) switchElement.handleOnchange(true);
            }
        },
        onSwitchesProcessed: () => {
            return new Promise((resolve) => {
                const checkSwitches = () => {
                    if (switchesProcessed) {
                        resolve();  
                    } else {
                        setTimeout(checkSwitches, 50);  
                    }
                };
                checkSwitches();
            });
        },
        getSwitch: function (id) {
            return getSwitch(id);
        },
        getAllSwitches: function () {
            return getAllSwitches();
        },
        setRevealTargets: function () {
            const revealTriggers = document.querySelectorAll(".reveal-target");
            revealTriggers.forEach(trigger => {
                const switchSelector = M2.Util.getSwitch(trigger.id);
                if (switchSelector) {
                    switchSelector.onChangeSuccess = function (state) {
                        var target = $(trigger).data("target");
                        if (state) {
                            $(target).removeClass("hidden");
                        } else {
                            $(target).addClass("hidden");
                            M2.Util.resetFormFields(target);
                        }
                    }
                }
            });
        },
        successMsg: function (target, callback) {
            if (typeof target === "undefined") target = ".message-area";
            $(target).fadeIn(function () {
                M2.Modal.resizeParentIframe();
            }).delay(1800).fadeOut(500, function () {
                M2.Modal.resizeParentIframe();
                if (callback) {
                    callback();
                }
            });
        },
        clearSearchBox: function (target, defaultText) {
            $(document).on("click", target, function (e) {
                if ($(this).val() === defaultText) $(this).val('');
            });
        },
        // Set File Uploads
        exists: function (elem) {
            if (elem.length > 0) return true;
        },
        resetFilter: function () {
            $(document).on("click", "a.reset", function (e) {
                e.preventDefault();
                const $resetLink = $(this);
                const $form = $resetLink.closest("form");
                $form.find("input[type='text']").val("");
                $form.find("input#IsSearchValueValidationActive").val("False");
                $form.find("select").val($(this).parent().parent().find("select option:first").val());
                $form.trigger("submit");
                const $searchTools = $(".search-tools");
                $searchTools.removeClass("hide");
                var $icon = $(".search-tools .btn").find('svg');
                $icon.attr('data-icon', 'caret-down');
            });
        },
        displayLoad: function (target) {
            $(target).html("<div class='loading-graphic' style='text-align: center; margin: 10% auto;'><img src='" + this.config.pathToImages + "loading-bar.gif' alt='Loading' /></div>");
        },
        activatePrint: function () {
            $(document).on("click", "a.print-report, .btn.print", function (e) {
                e.preventDefault();
                window.print();
                return false;
            });
        },
        submitForm: function (formRef, btnRef) {
            $(formRef).validate();
            if ($(formRef).valid()) {

                disableSubmission(btnRef);
                $(formRef).submit();
            } else {
                enableSubmission(btnRef);
            }
        },
        buildAddressSuggestions: function (label, address1, address2, city, state, zip, group, index, checked) {
            var address_choice = $("<div>").attr({
                "class": "address-choice form-check",
                "id": "address-choice-" + index
            });

            var address_selector = $('<input>').attr({
                type: 'radio',
                name: 'verifiedAddress' + group,
                value: '#address-choice-' + index,
                class: 'form-check-input',
                id: 'address-' + group + '-' + index
            });

            if (checked) address_selector.attr("checked", "checked");

            var address_container = $('<label>').attr('class', 'address form-check-label').attr('for', 'address-' + group + '-' + index);
            var label_container = $('<span>').attr('class', 'address-label').html(label);
            var address1_container = $("<span>").attr("class", "address1").html(address1);
            var address2_container = $("<span>").attr("class", "address2").html(address2);
            var city_state_zip_container = $("<span>").attr("class", "city-state-zip");

            var city_container = $("<span>").attr("class", "city").html(city + ",");
            var state_container = $("<span>").attr("class", "state").html(state);
            var zip_container = $("<span>").attr("class", "zip").html(zip);
            address_container.append(label_container, address1_container, address2_container, city_state_zip_container);
            address_container.append(city_state_zip_container);
            city_state_zip_container.append(city_container, state_container, zip_container);
            address_choice.append(address_selector, address_container);

            return address_choice;
        },
        createOverlayBG: function (id) {
            if (!M2.Util.exists($('#' + id))) {
                // main overlay container
                $('<div id="' + id + '" class="' + id + '">').css({
                    "width": "100%"
                    , "height": "100%"
                    , "background": "#000"
                    , "position": "fixed"
                    , "top": "0"
                    , "left": "0"
                    , "zIndex": "50"
                    , "MsFilter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=60)"
                    , "filter": "alpha(opacity=60)"
                    , "MozOpacity": 0.6
                    , "KhtmlOpacity": 0.6
                    , "opacity": 0.6

                }).appendTo($('.inner-content'));
            }
        },
        setSearchTools: function () {
            $(document).on("click", ".search-tools", function (e) {
                e.preventDefault();
                var $icon = $(this).find('svg');

                if ($(this).hasClass("hide")) {
                    $(".filter-table").fadeOut().addClass("hidden");
                    $(this).removeClass("hide");
                    $icon.attr('data-icon', 'caret-down');
                } else {
                    $(".filter-table").hide().removeClass("hidden").fadeIn("slow");
                    $(this).addClass("hide");
                    $icon.attr('data-icon', 'circle-xmark');
                }

            });
        },
        setDates: function () {
            // DatePickerCollection
            const datePickerCollection = document.querySelectorAll(".date-picker");
            datePickerCollection.forEach(picker => {
                const datePicker = new DatePicker(picker);
                saveDatePicker(picker.id, datePicker);
            });
        },
        setSingleDatePicker: function (elem) {
            const datePicker = new DatePicker(elem);
            saveDatePicker(elem.id, datePicker);
        },
        getDatePicker: function (id) {
            return getDatePicker(id);
        },
        setTimePicker: function () {
            $('body').on("focus", ".time-picker:not(.inactive)", function () {
                $(this).timepicker({
                    timeFormat: 'h:mm p',
                    dynamic: false,
                    dropdown: false
                });
            });
        },
        select2iFrameHeightAdjust: function (target, iframe) {
            $(document).on('select2:open', target, function (evt, params) {
                M2.Modal.resizeParentIframe();
            });

            $(document).on('select2:close', target, function (evt, params) {
                M2.Modal.resizeParentIframe();
            });
        },
        decorateField: function () {
            $("input.field-icon").each(function () {
                var classNames = $(this).attr("class");
                var updatedClass = classNames.replace("form-control", "");
                $(this).wrap("<div class='" + updatedClass + "'></div>");
            });
        },
        getParameterByName: function (name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        },
        setGroupSearch: function () {
            const $groupSearchSelect = $(".group-search.ajax");
            const placeholder = $groupSearchSelect.data("placeholder");
            const searchUrl = $groupSearchSelect.data("group-search-url");
            const paramName = $groupSearchSelect.data("param-name");
            const $groupSearch = groupSearch($groupSearchSelect, placeholder, searchUrl, paramName);
            $groupSearch.select2('open').select2('close');
        },
        setTroopSearch: function (searchUrl, width) {
            width = width || "auto";

            $(".troop-search.ajax").select2({
                minimumResultsForSearch: 10,
                dropdownAutoWidth: true,
                minimumInputLength: 1,
                width: width,
                placeholder: 'Search Troop...',
                ajax: {
                    url: function (params) {
                        const select = this[0];
                        return searchUrl ? searchUrl : select.dataset.groupSearchUrl
                    },
                    dataType: 'json',
                    delay: 500,
                    data: function (params) {
                        var query = {
                            'Identifier': params.term
                        };
                        return query;
                    },
                    processResults: function (data) {
                        var select2Format = [];
                        Object.keys(data).forEach(function (key) {
                            var jsonData = {};
                            if (data[key].GroupId === '') data[key].GroupId = 'null';
                            jsonData['id'] = data[key].groupId;
                            jsonData['text'] = data[key].identifier;
                            select2Format.push(jsonData);
                        });
                        return {
                            results: select2Format
                        };
                    }
                }
            }).select2('open').select2('close');
        },
        setSelect2: function (tmpTarget, tmpCollection, placeholder, width) {
            placeholder = placeholder || "Choose...";
            width = width || "auto";
            $(tmpTarget).select2({
                minimumResultsForSearch: 10,
                placeholder: placeholder,
                width: width
            });
            //Save Values
            $(document).on("change.select2", tmpTarget, function (e, params) {
                const values = $(tmpTarget).val();
                $(tmpCollection).val(values);
            });
        },
        setInputMasks: function () {
            $('body').on("focus", ".phone-number:not(.inactive)", function () {
                $(this).mask('000-000-0000');
            });
        },
        setAddDrilldownPage: function () {
            $(document).on("click", ".drilldown-page", function (e) {
                e.preventDefault();
                removeActionMenu();
                var drilldownUrl = $(this).data("drilldown-url");
                var drilldownLoadingTarget = $(this).data("loading-target");
                var drilldownSuccess = $(this).data("success");
                var drilldownTarget = $(this).data("drilldown-target");

                $.ajax({
                    url: drilldownUrl,
                    method: "GET",
                    beforeSend: M2.Util.displayLoad(drilldownLoadingTarget)
                }).done(function (data) {
                    $(drilldownTarget).html(data);
                    try {
                        eval(drilldownSuccess);
                    } catch (e) {
                        if (e instanceof SyntaxError) {
                            alert(e.message);
                        }
                    }
                });
            });
        },
        isRowClickAllowed: function (target) {
            return !$(target).is('.am') &&
                !$(target).parents('.am').length &&
                !$(target).is('.action-menu-trigger.active') &&
                !$(target).parents('.action-menu-trigger.active').length &&
                !$(target).is("action-menu") &&
                !$(target).closest('.action-menu').length &&
                !$(target).parent(".action-menu").length &&
                !$(target).is('am-item-label') &&
                !$(target).parents(".no-data-available").length &&
                !$(target).is(".no-data-available") &&
                !$(target).parents(".noclick").length &&
                !$(target).is(".noclick") &&
                !$(target).parents(".delete").length &&
                !$(target).is(".delete") &&
                !$(target).parents(".empty").length &&
                !$(target).is(".empty") &&
                !$(target).parents(".no-overlay").length &&
                !$(target).is(".no-overlay") &&
                !$(target).parents(".noclick").length &&
                !$(target).is(".noclick");
        },
        setDrilldownTableRow: function () {
            $(document).on("click", "table.data.drilldown-row tr td", function (e) {
                var allowClick = M2.Util.isRowClickAllowed(e.target);

                if (allowClick) {
                    var drilldownUrl = $(this).parent().data("drilldown-url");
                    var drilldownLoadingTarget = $(this).parent().data("loading-target");
                    var drilldownSuccess = $(this).parent().data("success");
                    var drilldownTarget = $(this).parent().data("drilldown-target");

                    $.ajax({
                        url: drilldownUrl,
                        beforeSend: M2.Util.displayLoad(drilldownLoadingTarget)
                    }).done(function (data) {
                        $(drilldownTarget).html(data);
                        eval(drilldownSuccess);
                    });
                }

            });
        },
        setDrilldownLink: function () {
            $(document).on("click", ".drilldown-link", function (e) {
                e.preventDefault();
                const drilldownUrl = $(this).attr("href");
                const drilldownLoadingTarget = $(this).data("loading-target");
                const drilldownSuccess = $(this).data("success");
                const drilldownTarget = $(this).data("drilldown-target");

                $.ajax({
                    url: drilldownUrl,
                    beforeSend: function() {
                        M2.Util.closeActionMenu();
                        M2.Util.displayLoad(drilldownLoadingTarget);
                    }
                }).done(function (data) {
                    $(drilldownTarget).html(data);
                    eval(drilldownSuccess);
                });
            });
        },
        resetFormFields: function (target) {
            $(target).find(':input').each(function () {
                switch (this.type) {
                    case 'password':
                    case 'text':
                    case 'textarea':
                    case 'file':
                    case 'select-one':
                    case 'select-multiple':
                    case 'date':
                    case 'number':
                    case 'tel':
                    case 'email':
                        $(this).val('');
                        break;
                    case 'checkbox':
                        if (this.checked) {
                            const switchSelector = M2.Util.getSwitch(this.id);
                            if (switchSelector) {
                                switchSelector.setCheckState(false);
                            } else {
                                $(this).trigger("click");
                            }
                        }
                        break;
                    case 'radio':
                        this.checked = false;
                        break;
                }
            });
        },
        delay: function () {
            var timer = 0;
            return function (callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        },
        stopMediaPlayer: function () {
            // Stop any videos that are playing
            try {
                //Loop and Stop
                let i;
                const videoPlayers = M2.Video.getAllPlayers();
                for (var key in videoPlayers) {
                    videoPlayers[key].pause();
                }
            } catch (err) {
                console.log(err.message);
            }
        },
        getBase64Image: function (url, callback) {
            var img = new Image();
            img.src = url;

            img.onload = function () {
                var canvas = document.createElement("canvas");
                canvas.width = this.width;
                canvas.height = this.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(this, 0, 0);
                const viewData = canvas.toDataURL("image/png"); //.replace(/^data:image\/(png|jpg);base64,/, '');
                callback(viewData);
            };
        },
        tabSelectOnBegin: function (trigger) {
            if (trigger.classList.contains('active') && $(window).width() <= '992') return false;
            M2.Util.displayLoad(".tabbed-content");
        },
        closeActionMenu: function () {
            removeActionMenu();
        },
        setCurrencyCommas: function(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        jumpToTop: function () {
            window.scrollTo(0, 0);
        },
        textAreaLimiter: function () {
            const textAreas = document.getElementsByTagName('textarea');
            for (let i = 0; i < textAreas.length; i++) {
                const textArea = textAreas[i];
                textArea.addEventListener('keyup', function () {
                    const charsEntered = textArea.value;
                    const maxLength = textArea.maxLength;
                    const rawCharCount = charsEntered.length;
                    const adjustedCharCount = getAdjustedCharacterCount(charsEntered);

                    if (maxLength > 0) {
                        let remainingChars = maxLength - adjustedCharCount;
                        textArea.dataset.remainingCharacters = remainingChars;
                        if (remainingChars < 0) {
                            textArea.value = textArea.value.substr(0, maxLength - getNumLineBreaks(charsEntered));
                            textArea.dataset.remainingCharacters = 0;
                        }
                    }
                }, false);
            }
        },
        setiframeSelfResize: function () {
            $("iframe.auto-size").each(function (index, el) {
                const iframe = el;
                iframe.onload = function () {
                    var iframeRef = this;
                    try {
                        iframeRef.height = (iframeRef.contentWindow.document.body.scrollHeight) + "px";
                    } catch (e) {
                        console.log(e);
                    }
                };
            });
        },
        isIframe: function () {
            const isIframe = window.self !== window.top;
            return isIframe;
        },
        // TODO: Phase this out
        searchTroop: function () {
            function split(val) {
                return val.split(/,\s*/);
            }
            $(".group-search").bind("keydown", function (event) {
                if (event.keyCode === $.ui.keyCode.TAB && $(this).data("ui-autocomplete").menu.active) {
                    event.preventDefault();
                }
            }).autocomplete({
                source: function (request, response) {
                    $.getJSON('../Utility/GroupLookupByIdentifier?Identifier=' + request.term, function (data) {
                        response($.map(data, function (item) {
                            return {
                                label: item.Identifier,
                                value: item
                            };
                        }));
                    });
                },
                focus: function (event, ui) {
                    // prevent autocomplete from updating the textbox
                    event.preventDefault();
                    // manually update the textbox
                    var selectedGroup = ui.item.value;
                    if ($(this).hasClass("multi")) {
                        // prevent value inserted on focus
                        return false;
                    } else {
                        $(this).val(selectedGroup.Identifier);
                    }
                },
                select: function (event, ui) {
                    event.preventDefault();
                    var selectedGroup = ui.item.value;
                    var groupId = selectedGroup.GroupId;
                    var identifier = selectedGroup.Identifier;
                    var selectedGroupIds = $(this).parent().parent().parent().find(".selected-group-ids");
                    var selectedGroups = $(this).parent().parent().parent().find(".selected-groups");

                    if ($(this).hasClass("multi")) {
                        // Add Element to listing, only if it hasn't already been added
                        if (!$(selectedGroups).find("li").hasClass("selected-" + groupId)) {
                            $('<a/>', {
                                'href': '#',
                                'data-val': groupId,
                                'class': 'removeGroup',
                                'html': 'Remove'
                            }).click(function () {
                                tmpGrpId = $(this).attr("data-val");
                                currentGroups = selectedGroupIds.val();
                                // Remove the selected item
                                arr = currentGroups.split(','); // Convert Back to Array
                                arr.splice($.inArray(tmpGrpId, arr), 1); // Remove the item
                                selectedGroupIds.val(arr.join()); // Save string to hidden input
                                $(selectedGroups).find("li.selected-" + tmpGrpId).remove(); // Remove List Item
                            }).appendTo(
                                $('<li/>', {
                                    'class': 'selected-group selected-' + groupId,
                                    'html': "<span>" + identifier + "</span>"
                                }).appendTo($(selectedGroups)));

                            // Record the answer in a hidden input
                            var selectedGroupValues = selectedGroupIds.val(); // Grab current values

                            groups = selectedGroupValues.split(','); // Convert Back to Array

                            // remove the first empty
                            if (groups[0] === "") groups.pop(); //If the first element is empty, get rid of it
                            groups.push(groupId);  // add the selected item
                            selectedGroupIds.val(groups.join()); // Save string to hidden input
                        }
                        // Clear Input
                        $(this).val(""); // Clear the search field, with multi we store them in a list
                    } else {
                        selectedGroupIds.val(groupId); // Save the value in a hidden input
                        $(this).val(identifier); // Save the identifier in the search field
                    }
                },
                change: function (event, ui) {
                    // Prevent users from picking something other than what is available in a drop down
                    if (!ui.item) {
                        var matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex($(this).val()) + "$", "i"), valid = false;
                        $(this).children("option").each(function () {
                            if ($(this).text().match(matcher)) {
                                this.selected = valid = true;
                                return false;
                            }
                        });

                        if (!valid) {
                            // remove invalid value, as it didn't match anything
                            $(this).val("");
                            return false;
                        }
                    }
                }
            });
        }
    };
})(jQuery);

$(function () {
    M2.Util.init();
});